import { useIsMobile } from '@hooks';
import Modal from '@components/Modal';
import { FC, useState } from 'react';
import PriceSelector from '@components/PriceSelector';
import * as tsClient from '@tsClient';
import Spacer from '@components/Spacer/Spacer';
import Buttons from '@components/Buttons/Buttons';
import useNoodleApi from '@hooks/useNoodleApi';
import s from './AttachPriceToInvoiceModal.module.scss';

type Props = {
  onClose: () => Promise<void>;
  invoiceId: string;
};

type Price = NonNullable<Parameters<typeof PriceSelector>[0]['selectedPrice']>;

const AttachPriceToInvoiceModal: FC<Props> = ({ invoiceId, onClose }) => {
  const [isAttachingPrice, setIsAttachingPrice] = useState(false);
  const [price, setSelectedPrice] = useState<Price | null>(null);
  const isMobile = useIsMobile();
  const { getData: attachPriceToInvoiceFn } = useNoodleApi(tsClient.invoices.attachPriceToInvoice);

  const handlePriceSelect = (newPrice: Price): void => {
    setSelectedPrice(newPrice);
  };
  const handleSubmit = async (): Promise<void> => {
    if (!price?.id) {
      return;
    }
    setIsAttachingPrice(true);
    await attachPriceToInvoiceFn({ invoiceId, priceId: price.id });
    await onClose();
  };
  return (
    <Modal
      hideBottomInset
      isPinnedToBottom={isMobile}
      title='Generate Invoice'
      onClose={onClose}
      hasCloseOnActions={false}
    >
      <div className={s.container}>
        <p className='body-sm-bold'>Select price</p>
        <Spacer size='24px' />
        <PriceSelector onPriceSelect={handlePriceSelect} selectedPrice={price} canCreateNewPrice />
        <Spacer size='24px' />
        <Buttons isFetching={isAttachingPrice} disabled={!price?.id} isSecondary isFullWidth onClick={handleSubmit} className={s.button}>
          Submit
        </Buttons>
      </div>
    </Modal>
  );
};

export default AttachPriceToInvoiceModal;
